export enum FirmwareType {
  GW = 'GW',
  APP = 'APP',
}
